import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}

export default function EmptyState({
  icon = "ri-search-eye-line",
  title,
  description,
  actions,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      {description && (
        <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      )}
      {actions && <div className="mt-6 flex flex-wrap items-center justify-center gap-3">{actions}</div>}
    </div>
  );
}